(function () {
  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function initBlock(block) {
    if (!block || block.getAttribute('data-phl-ready') === 'true') return;
    block.setAttribute('data-phl-ready', 'true');

    var wrap = block.querySelector('[data-phl-wrap]');
    var body = block.querySelector('.phl__body');
    var btn = block.querySelector('[data-phl-toggle]');
    var moreLabel = block.querySelector('[data-phl-more]');
    var lessLabel = block.querySelector('[data-phl-less]');
    if (!wrap || !body || !btn) return;

    var lines = parseInt(wrap.getAttribute('data-phl-lines') || '5', 10);
    if (isNaN(lines) || lines < 1) lines = 5;

    wrap.classList.add('is-collapsed');
    wrap.classList.remove('is-expanded');
    btn.setAttribute('aria-expanded', 'false');

    var style = window.getComputedStyle(body);
    var lineHeight = parseFloat(style.lineHeight);
    if (isNaN(lineHeight) || lineHeight <= 0) {
      lineHeight = parseFloat(style.fontSize) * 1.7;
    }
    var maxHeight = lineHeight * lines;

    if (body.scrollHeight <= maxHeight + 4) {
      wrap.classList.remove('is-collapsed');
      btn.hidden = true;
      return;
    }

    btn.hidden = false;
    if (moreLabel) moreLabel.hidden = false;
    if (lessLabel) lessLabel.hidden = true;

    btn.addEventListener('click', function () {
      var expanded = !wrap.classList.contains('is-expanded');
      wrap.classList.toggle('is-expanded', expanded);
      wrap.classList.toggle('is-collapsed', !expanded);
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (moreLabel) moreLabel.hidden = expanded;
      if (lessLabel) lessLabel.hidden = !expanded;
    });
  }

  function initRoot(root) {
    if (!root) return;
    toArray(root.querySelectorAll('[data-phl-block]')).forEach(initBlock);
  }

  function boot() {
    toArray(document.querySelectorAll('[data-phl]')).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    toArray(event.target.querySelectorAll('[data-phl]')).forEach(function (root) {
      toArray(root.querySelectorAll('[data-phl-block]')).forEach(function (block) {
        block.removeAttribute('data-phl-ready');
      });
      initRoot(root);
    });
  });
})();
